module.exports = __webpack_public_path__ + "media/scholarship_winners/shay-s-b187c1e9.png";